import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("jwt");

  if (!token) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;
